import ApiInterface from "utils/ApiInterface";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export async function addUsersGuestToTeamApi(org_id, email, role, team_id) {
  console.log("ADD API CALLED: ");
  try {
    const response = await ApiInterface.instance.addUserGuestToTeam(
      org_id,
      email,
      role,
      team_id
    );
    console.log("response in get teams: ", response);
    return response;
  } catch (error) {
    if (error) {
      console.log("Error in ADD USER: ", error);
      const { response } = error;
      console.log(response);
      let errorMessage = error?.response?.data?.message;
      if (!!errorMessage) {
        withReactContent(Swal).fire({
          title: "Error",
          html: errorMessage,
        });
      }
    }
  }
}
